module.exports = __webpack_public_path__ + "img/imgl2.9c985873.jpg";